import Vue from 'vue';

const success = (context, response, type) => {
  if (response.bookingHaveResource) {
    context[`${type}Resource`] = true;
    // context.smallLoading = type === 'passport' && false;
  }
};

const failed = (context, error, type) => {
  context[`${type}Resource`] = false;
  context.showToasterError(error);
  context.smallLoading = false;
};

export default (context, permalink, type) => {
  return Vue.$http.post(`check-booking-resource/${permalink}`, {type, lang: Vue.config.lang})
    .then(response => {
      if (response && response.status === 200) {
        success(context, response.data, type)
      } else {
        failed(context, response, type)
      }
    }).catch(error => {
      if (error) {
        failed(context, error, type)
      }
    })
}



// WEBPACK FOOTER //
// ./src/app/services/booking/checkBookingResource.js